module.exports = __webpack_public_path__ + "img/logo.1a260b4f.png";